/**
 * Поиск по списку на клиенте — одно правило на всю админку и кабинет куратора (28.09.2026, вторая волна п. 8–11).
 *
 * Там, где список приходит целиком (кураторы, «Мои ученики», состав группы, подтипы), ищем здесь; где страницами
 * (ученики, курсы, очередь домашек) — на сервере.
 */

/** Нижний регистр, «ё» = «е» (в именах их пишут как попало), пробелы схлопнуты. */
export function normalizeForSearch(s: string | null | undefined): string {
  return (s ?? '').toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();
}

/**
 * Подходит ли строка списка под запрос: каждое слово запроса должно найтись хоть в одном поле. «айгерим pre-upper»
 * находит ученицу Айгерим на курсе PRE-UPPER, хотя имя и курс — разные поля. Пустой запрос подходит всем.
 */
export function matchesSearch(fields: readonly (string | null | undefined)[], query: string): boolean {
  const words = normalizeForSearch(query).split(' ').filter(Boolean);
  if (!words.length) return true;
  const hay = fields.map(normalizeForSearch).join('\n');
  return words.every((w) => hay.includes(w));
}
